module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA24"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.25.0.0.box.655.357.1197.177.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.25.0.0.box.655.357.1197.88.q.70"
    }
  }, [_vm._v("Maj. Gen. Robert F. Hoke")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.25.0.1.box.940.470.631.64.q.80"
    }
  }, [_vm._v("Headquarters Flag")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.25.1.0.box.303.548.1898.1213.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.4.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0024.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.4.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.25.2.0.box.310.1796.1886.1031.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.2.0.box.312.1796.1882.357.q.50"
    }
  }, [_vm._v("Robert F. Hoke was born in Lincolnton, North Carolina, on May 27, 1837, and educated at the Kentucky Military Institute. He entered the military service of the state in April 1861, as a member of Company K, 1st Regiment Volunteers. He was immediately commissioned as a 2nd lieutenant, and as captain was commended for \"coolness, judgment and efficiency\" in D. H. Hill's report of the battle of Big Bethel. In September, he became major of the 1st Regiment.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.2.1.box.314.2166.1882.360.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.4.1.0"
    }
  }), _vm._v("At the reorganization, he was commissioned lieutenant colonel of the 33rd Regiment. He commanded five companies at New Berne, on March 14, 1862, and was distinguished for gallantry. When the colonel was captured at New Berne, Hoke was given command of the regiment and, as a part of Branch's Brigade, led them in the Virginia battles of Hanover Court House, Mechanicsville, Gaines' Mill, Frayser's Farm, and Malvern Hill.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.2.2.box.310.2540.1885.287.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.4.2.0"
    }
  }), _vm._v("After promotion to colonel, Hoke led the regiment at 2nd Manassas and Sharpsburg. On Colonel Avery's return, Hoke was given command of the 21st Regiment North Carolina State Troops. He led this regiment through the battle of Fredericksburg, where he earned the praises of both Generals Early and Jackson.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA25"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.26.0.0.box.1330.1042.732.946.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.0.1.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0025.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.0.1.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.26.1.0.box.304.354.1891.2477.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.0.box.305.354.1881.301.q.60"
    }
  }, [_vm._v("In January 1863, Hoke was promoted to brigadier general and given command of Trimble's Brigade, composed of the 6th, 21st, 54th, and 57th North Carolina Regiments and the 1st North Carolina Battalion. During the battle of Chancellorsville, he was severely wounded. This wound prevented his participation in the Pennsylvania campaign.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.1.box.306.667.1880.112.q.60"
    }
  }, [_vm._v("Recovering from his injuries, he reported back for duty. His brigade was sent to North Carolina, where it fought in the attempt to retake New Berne.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.2.box.305.792.1888.366.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.0.2.0"
    }
  }), _vm._v("On April 17, 1864, Hoke's Brigade attacked the Federal forts at Plymouth, North Carolina, vigorously pushing assaults while the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("C.S.S. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Albemarle ")]), _vm._v("attacked the coastal batteries and ships from the river. Due to the tremendous success of this operation, Hoke was promoted to major general, the commission bearing the date of his victory.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.3.box.305.1172.902.798.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.0.3.0"
    }
  }), _vm._v("As the situation became more tenuous in Virginia, Hoke was sent to join General Beauregard, and on May 10 was given command of six brigades and sent to Drewry's Bluff. His conduct of this fight was superb. One of his brigades, Hagood's, captured five pieces of artillery. At Cold Harbor he held one of the most important parts of the line with his division, repelling furious assaults, and fought in the June battles at Petersburg.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.4.box.305.1984.1884.350.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.0.4.0"
    }
  }), _vm._v("In December 1864, he was moved with his division to Wilmington to confront Butler's attack on Fort Fisher. He foiled the first attack on the fort. In the second assault, Hoke advanced two brigades and drove in the enemy's pickets. Unfortunately, General Bragg, fearful of an enemy attack on Wilmington, called back Hoke's forces. Fort Fisher was lost.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.5.box.307.2358.1887.296.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.0.5.0"
    }
  }), _vm._v("At the battle of Bentonville, Hoke's division consistently repelled the advances of Sherman's army. With extreme bravery and presence of mind, Hoke turned disaster into victory at each point he met the enemy, earning the praises of General Hampton, who said, \"Bragg, by reason of his rank, was in command of this division, but it was really Hoke's division, and Hoke directed the fighting.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.6.box.304.2667.1891.164.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.0.6.0"
    }
  }), _vm._v("On May 1, 1865, after the surrender of General Johnston's A"), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.2.0.0"
    }
  }), _vm._v("rmy of Tennessee at Durham, General Hoke issued a farewell address to his division, in which he said:")])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA26"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.27.0.0.box.316.358.1879.757.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.27.0.0.box.334.358.1845.259.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.0.0.0"
    }
  }), _vm._v("\"You ")]), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.0.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.0.0"
    }
  }), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("are ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("paroled ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("prisoners, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("not ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("slaves. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("love ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("liberty ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("which ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("led ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("into ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("con")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("test ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("burns ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("as ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("brightly ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("your ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hearts ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("as ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ever. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Cherish ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("it. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Associate ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("it ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("with ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("history ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("your ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("past. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Transmit ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("it ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("your ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("children. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Teach ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("them ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("rights ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("freemen ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("teach ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("them ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("maintain ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("them. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Teach ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("them ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("proudest ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("day ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("all ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("your ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("proud ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("career ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("was ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("that ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("on ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("which ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("enlisted ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("as ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Southern ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("soldiers.")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\" ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.0.1.box.316.691.1879.298.q.30"
    }
  }, [_vm._v("Maj. Gen. Robert F. Hoke's headquarters flag is a 2nd National. It is 47\" (hoist) x 70\" (fly). The canton is 31\" (hoist) x 34\" (fly). The red field of the canton is crossed with 5\"-wide blue bars forming a St. Andrew's cross, which is edged with "), _c('span', {
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.2.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "xh\"",
      "src": "data/content-0026.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.2.0.0.1"
    }
  })]), _vm._v("white cotton fimbriation. Thirteen white cotton stars, "), _c('span', {
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.2.0.0.2"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "47/«\"-5\"",
      "src": "data/content-0027.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.2.0.0.3"
    }
  })]), _vm._v("point to point, are sewn to the cross.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.0.2.box.392.1067.1158.48.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("North ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Carolina ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Museum ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("History, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Raleigh, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("N.C. ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99f1f714","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0028.vue
// module id = 69
// module chunks = 0